import File from './file';
import Corner from './corner';

export default {
  File,
  Corner,
};
